export const COB_PAPERLESS_SET_ANSWER = 'COB_PAPERLESS_SET_ANSWER';
export const COB_PAPERLESS_LOAD_ANSWER = 'COB_PAPERLESS_LOAD_ANSWER';
export const COB_PAPERLESS_COMPONENT_COMPLETE =
  'COB_PAPERLESS_COMPONENT_COMPLETE';
export const COB_PAPERLESS_CLEAR_ANSWER = 'COB_PAPERLESS_CLEAR_ANSWER';
